import React from 'react';
import { TextBlockWithTitle } from 'components';
import { convertFileSize } from 'utils/files/convertFileSize';
import DownloadIcon from 'components/SvgIcons/ComplexIcons/download-icon.svg';
import PdfIcon from 'components/SvgIcons/ComplexIcons/pdf-icon.svg';
import JpgIcon from 'components/SvgIcons/ComplexIcons/jpg-icon.svg';
import DocIcon from 'components/SvgIcons/ComplexIcons/doc-icon.svg';

export const documentsIcons = {
  pdf: <PdfIcon />,
  jpg: <JpgIcon />,
  jpeg: <JpgIcon />,
  doc: <DocIcon />,
  docx: <DocIcon />,
};

export const DocumentItem = ({
  field,
  title,
  tooltipInfo,
  tooltipWidth,
  description,
  descriptionClassName,
}) => {
  const getFormatIcon = (format) => {
    return documentsIcons[format];
  };

  const getFileFormat = (fileName) => {
    return fileName.split('.')[fileName.split('.').length - 1];
  };

  const loadFile = async (url) => {
    window.open(url, '_blank');
  };

  return (
    <TextBlockWithTitle
      title={title}
      text={field.map((item, index) => (
        <div
          className="flex align-items-center justify-content-space-between mb-6"
          key={index}
        >
          <div className="flex align-items-center">
            <span>{getFormatIcon(getFileFormat(item.name))}</span>
            <span className="ml-2">{item.fileName}</span>
          </div>
          <div className="flex align-items-center">
            <span className="mr-10">{convertFileSize(item.fileSize)}</span>
            <div onClick={() => loadFile(item.urls.original)}>
              <DownloadIcon className="mr-2" style={{ cursor: 'pointer' }} />
              <span className="title red_text" style={{ cursor: 'pointer' }}>
                Download
              </span>
            </div>
          </div>
        </div>
      ))}
      description={description}
      descriptionClassName={descriptionClassName}
      tooltipInfo={tooltipInfo}
      tooltipWidth={tooltipWidth}
    />
  );
};
